export const SPECS = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  CartOOIThunderboltCSSOptimization: 'specs.stores.CartOOIThunderboltCSSOptimization',
  ShouldUseOpenSideCartApiInAddToCart: 'specs.stores.ShouldUseOpenSideCartApiInAddToCart',
  ShouldUseEcomPlatformPublicApiAddToCartInPP: 'specs.stores.ShouldUseEcomPlatformPublicApiAddToCartInPP',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  ExpressCheckoutInSideCart: 'specs.stores.ExpressCheckoutInSideCart',
  ShowCssPerBreakpointIndicationsSideCart: 'specs.stores.ShowCssPerBreakpointIndicationsSideCart',
  UseAllStylesInCart: 'specs.stores.UseAllStylesInCart',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  CartFromSDKWhenShowShippingOrShowTax: 'specs.stores.CartFromSDKWhenShowShippingOrShowTax',
  UseCurrentCartFromSdk: 'specs.stores.UseCurrentCartFromSdk',
  ShouldNotUseDestinationCompleteness: 'specs.stores.ShouldNotUseDestinationCompleteness',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  GiftCardAddToCartSettings: 'specs.stores.ShowGiftCardAddToCartSettings',
  FixRedundantGetAfterUpdate: 'specs.stores.FixRedundantGetAfterUpdate',
  SendCartLoadedAfterEstimate: 'specs.stores.SendCartLoadedAfterEstimate',
  CatchEstimateTotalsError: 'specs.stores.CatchEstimateTotalsError',
  UseProductThumbnailWithWowImage: 'specs.stores.UseProductThumbnailWithWowImage',
  FixHandleCreateCheckoutError: 'specs.ecom.FixHandleCreateCheckoutError',
  FixCustomLineItemImage: 'specs.ecom.FixCustomLineItemImage',
  RefactorCartCouponSection: 'specs.ecom.RefactorCartCouponSection',
  HandleNoCheckoutIdError: 'specs.ecom.HandleNoCheckoutIdError',
  UseDeliveryOptionsLibInCart: 'specs.ecom.UseDeliveryOptionsLibInCart',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  FixCarrierIdForSelectShippingOption: 'specs.ecom.FixCarrierIdForSelectShippingOption',
} as const;
